// extracted by mini-css-extract-plugin
export var boxItems = "_99-1";
export var boxItemsLg = "_99-2";
export var button = "_99-7";
export var buttonHoverless = "_99-9";
export var buttonLg = "_99-8";
export var filterGroupBox = "_99-0";
export var icon = "_99-3";
export var iconSecondary = "_99-6";
export var iconWrapper = "_99-4";
export var iconWrapperLg = "_99-5";
export var truncatedLabel = "_99-a";